export interface RouteChangeCallbacks {
  onSlideMainDrawerOutEnd;
}

export const resetToFarRight = (el: HTMLElement) => {
  el.style.translate = "150%";
  el.style.position = "relative";
};

export const mainDrawerHTMLSelector = "#main-drawer > div:first-child";
